import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import type { ProposalExtraItemType } from '@econtractor/types';
import AdditionalItemsTableRow, { type AdditionalItemsTableRowProps } from './AdditionalItemsTableRow';

type AdditionalItemsTableBodyProps = Omit<AdditionalItemsTableRowProps, 'row' | 'index' | 'sortableId'> & {
    items: ProposalExtraItemType[];
    sortable?: boolean;
};

const AdditionalItemsTableBody = ({
    items,
    sortable = false,
    table,
    ...rowProps
}: AdditionalItemsTableBodyProps) => {
    const rows = items.map((row, index) => (
        <AdditionalItemsTableRow
            key={table.getRowId(row, index)}
            row={row}
            index={index}
            sortableId={sortable ? table.getRowId(row, index) : undefined}
            table={table}
            {...rowProps}
        />
    ));

    return (
        <tbody>
            {sortable ? (
                <SortableContext
                    items={items.map((row, index) => table.getRowId(row, index))}
                    strategy={verticalListSortingStrategy}
                >
                    {rows}
                </SortableContext>
            ) : (
                rows
            )}
        </tbody>
    );
};

export default AdditionalItemsTableBody;
